var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinDef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    stroke: "#450A0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 9.71147L18.733 13.9786H22.7916V14.9848H17.5185C17.2407 14.9848 17.0154 14.7596 17.0154 14.4817V9.20838H18.0216V13.2672L22.2886 9L23 9.71147ZM9.20838 17.0152H14.4815C14.7593 17.0152 14.9846 17.2404 14.9846 17.5183V22.7916H13.9784V18.7328L9.71144 23L9 22.2885L13.267 18.0214H9.20838V17.0152Z",
    fill: "#450A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinDef);
export default __webpack_public_path__ + "static/media/min-def.488cc8be35fc192e1259190fd86e36f2.svg";
export { ForwardRef as ReactComponent };